import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { env } from "../env";
import { getLocalStorage } from "../utils/function/localStorage";

export const fundTransferApi = createApi({
  reducerPath: "fundTransferApi",
  baseQuery: fetchBaseQuery({
    baseUrl: env.BASE_URL,
    mode: 'cors',
    prepareHeaders: (headers) => {
      headers.set("authorization", getLocalStorage("tron_token"));
      return headers;
    },
  }),
  tagTypes: ["adminFundTransfer", "userFundTransfer"], // automatic-data fetching
  endpoints: (builder) => ({
    // admin
    fundTransferHistory: builder.query({
      query: () => "/private/api/fund_transfer_report",
      providesTags: ["adminFundTransfer"], // automatic-data fetching
    }),
  }),
});

export const {
  useFundTransferHistoryQuery
} = fundTransferApi;
